import React from "react";
import { css } from "@emotion/react";
import { Accordion, AccordionDetails, AccordionSummary, Divider, styled } from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useSearchParams } from "react-router-dom";
import { transferToNative } from "@src/lib/WebAppBridge";

interface Props {}

const SubscriptionUsingInfo: React.FC<Props> = () => {
    const [searchParams] = useSearchParams();
    const isApple = searchParams.get("type") === "7";
    const subscriptionUsingInfoTextList = [
        {
            title: "미스고 구독 상품 이용 안내",
            content: (
                <div css={contentStyle}>
                    <li>
                        본 동의서에서 사용하는 용어의 정의는 별도로 정하지 않는 한 [미스고 유료 서비스 이용약관]에 정의된 의미와
                        동일한 의미를 가집니다.
                    </li>
                    <li>
                        “미스고 구독상품“은 주식회사 미스고(이하 “회사“)가 제공하는 정보 등을 열람하기 위하여 필요한 일종의
                        이용권입니다. “미스고 구독상품“을 구매하시면 회사가 제공하는 정보 등을 열람하실 수 있습니다.
                    </li>
                    <li>
                        “국•공유지 검색추가권“은 주식회사 미스고(이하 “회사“)가 제공하는 국•공유지 필터를 이용하기 위하여 필요한
                        일종의 이용권입니다.
                    </li>
                    <li>
                        “확장예정 도로 데이터맵“은 주식회사 미스고(이하 “회사“)가 제공하는 확장예정 도로 안내 지도 서비스를
                        이용하기 위하여 필요한 일종의 이용권입니다.
                    </li>
                    <li>
                        “주거/ 토지 시세차익 필터“는 주식회사 미스고(이하 “회사“)가 제공하는 시세차익 등 필터 서비스를 이용하기
                        위하여 필요한 일종의 이용권입니다.
                    </li>
                    <li>
                        “상가 수익률 필터”은 주식회사 미스고(이하 “회사“)가 제공하는 상가의 예상수익률 계산 서비스를 이용하기
                        위하여 필요한 일종의 이용권입니다.
                    </li>
                    <li className="titleBox">구독 결제 방식 및 자동 갱신</li>
                    <li>2025년 4월 14일부터 신규 결제되는 모든 &quot;미스고 구독상품&quot;은 자동 결제 방식으로 운영됩니다.</li>
                    <li>자동 결제는 최초 결제 시점에 적용된 프로모션 금액으로 자동 결제됩니다.</li>
                    <li>자동결제는 구독 기간 마지막 날에 다음 정기구독 기간에 대한 금액이 결제됩니다.</li>
                    <li>
                        구독 기간 만료 시 등록된 결제 수단으로 자동 결제되며, 구독 기간 만료 7일 전과 1일 전 미스고 APP 푸시
                        알림으로 자동 결제 예정 안내 알림이 2회 발송됩니다.
                    </li>
                    <li>
                        등록된 결제수단의 유효기간 만료 등 여하의 사유로 정기결제일에 이용요금의 결제가 정상적으로 이루어지지
                        않으면 당일 1회 결제 재시도하며, 그 후에도 결제가 정상적으로 이루어지지 않을 경우 &quot;미스고
                        구독상품&quot; 자동 결제가 중단됩니다.
                    </li>
                    <li>
                        기존에 결제한 구독상품(2025년 4월 14일 이전)은 본 개정된 약관의 자동 결제 정책이 적용되지 않으며, 기존
                        약관에 따라 운영됩니다.
                    </li>
                    <li>구독 중도 해지의 경우 “미스고 구독 및 상품 해지/취소/환불 안내” 반드시 확인해주십시오.</li>
                    <li className="titleBox">구독 변경 및 업그레이드/다운그레이드</li>
                    <li>
                        미스고 구독상품을 이용중에는 다른 방식으로 변경할 수 있으며 구독 변경 시 이전 구독의 복구, 환불이
                        어렵습니다. 또한 변경 전 구독 잔여기간에 대한 연장 및 할인은 이루어지지 않습니다. (예를 들어 현재 1개월
                        단위 기간만료 유료 서비스 방식으로 이용 중일 경우 1년 단위 기간만료 유료 서비스 방식으로 변경할 수
                        있습니다.)
                    </li>
                    <li>
                        구독 상품 업그레이드 시(예: 베이직 → 프리미엄), 기존 구독권의 잔여 기간은 업그레이드된 구독 상품으로
                        전환되며, 업그레이드된 구독 기간이 종료된 후 자동 결제됩니다. (예: 베이직 1개월이 남았을 때 프리미엄
                        1년으로 업그레이드한 경우, 기존 베이직 1개월은 프리미엄 1개월로 변경되고, 프리미엄 1년 + 1개월 이후에 자동
                        결제됩니다.)
                    </li>
                    <li>
                        구독 상품 다운그레이드 시(예: 프리미엄 → 베이직), 현재 구독권 만료 후 다운그레이드된 구독 상품이
                        적용됩니다. 자동 결제 중인 경우, 기존 구독은 해지 처리되며 다운그레이드된 구독 상품으로 새롭게 결제됩니다.
                    </li>
                    <li className="titleBox">구독 상품 제공 서비스</li>
                    <li>
                        미스고 구독 상품은 &quot;미스고 베이직 구독상품(베이직,Basic)”, &quot;미스고 스탠다드 구독상품(스탠다드,
                        VIP Lite)”, &quot;미스고 프리미엄 구독상품(프리미엄, VIP Full 혹은 VVIP Full)”로 구성되어 있습니다
                    </li>
                    <li className="redBox">
                        모든 구독 상품은 데이터맵 및 매물/필지 상세 정보가 기본 제공되며, 각 상품별 추가되는 유료 서비스는
                        상이하므로, 구독 상품별 안내를 반드시 확인해야 하며, 주요 유료 서비스는 아래와 같습니다.
                    </li>
                    <li className="redBox">&quot;미스고 베이직 구독상품(베이직,Basic)” : 데이터맵 + 매물/필지 상세</li>
                    <li className="redBox">
                        &quot;미스고 스탠다드 구독상품(스탠다드, VIP Lite)” : 데이터맵 + 매물/필지 상세 + 확장예정 도로 데이터맵 +
                        월 3회 실시간 등기 열람권 + 기존 등기 무제한 열람 + 경매 캠퍼스 무제한 1달 수강
                    </li>
                    <li className="redBox">
                        &quot;미스고 프리미엄 구독상품(프리미엄, VIP Full )” : 데이터맵 + 매물/필지 상세 + 확장예정 도로 데이터맵+
                        월 3회 실시간 등기 열람권 + 기존 등기 무제한 열람 + 경매 캠퍼스 무제한 1달 수강 + 국공유지 필터 + 주거토지
                        시세차익 필터 + 상가수익률 필터 + 소유자 확인 이용권 + 토지대장/건축물대장 일 20장 제공 + AI 경매길잡이
                    </li>
                    <li className="redBox">
                        &quot;미스고 프리미엄 구독상품(프리미엄, VVIP Full )” : 데이터맵 + 매물/필지 상세 + 확장예정 도로
                        데이터맵+ 월 3회 실시간 등기 열람권 + 기존 등기 무제한 열람 + 경매 캠퍼스 무제한 1달 수강 + 국공유지 필터
                        + 주거토지 시세차익 필터 + 상가수익률 필터 + 소유자 확인 이용권 + 토지대장/건축물대장 일 20장 제공 + AI
                        경매길잡이 + AI 챗봇 + 매각결과 카톡 푸시 알람
                    </li>
                    <li>“미스고 구독상품“에서 지급된 등기부등본 실시간 열람권은 지급일로부터 30일 동안 사용할 수 있습니다.</li>
                    <li>“미스고 구독상품” 무료 체험 혹은 추가로 제공된 기간에는 등기부등본 실시간 열람권이 지급되지 않습니다.</li>
                    <li>
                        회사가 제공하는 모든 정보는 여러 유관기관에 광범위하게 퍼져 있는 정보를 손쉽게 이용할 수 있도록 정리하여
                        제공하는 것으로 이용자는 해당 정보를 참고 자료로만 활용하여야 하며, 회사는 해당 정보로 인해 발생한
                        이용자의 손해에 대해서는 법적 책임을 지지 않습니다.
                    </li>
                    <li>
                        예를 들어, 제공된 정보가 실제 매각 물건의 정보와 일치하지 않거나 정보 제공 이후 중요한 변동사항이 생길 수
                        있으므로, 이용자는 대법원의 관련 제반 정보(물건명세서, 현황조사서, 감정평가서 등)를 반드시 재확인한 후
                        입찰에 참여해야 하며, 이용자가 이러한 재확인 절차 없이 회사가 제공하는 정보만으로 참여한 입찰과 관련한
                        문제에 대해서 회사는 법적 책임을 지지 않으며, 이는 회사가 제공하는 모든 서비스에 동일하게 적용됩니다.
                    </li>
                    <li>본 약관은 25년 11월 13일부터 시행됩니다.</li>
                </div>
            ),
        },
        {
            title: "미스고 구독 해지/취소/환불 안내",
            content: (
                <div css={contentStyle}>
                    <li className="redBox">회원의 귀책사유로 인한 환불 시 아래 기준에 따라 공제 후 환불이 진행됩니다.</li>
                    <li className="redBox">
                        유료 상품은 결제 시(사용 개시)부터 7일 이내 서비스 미이용 시 전액 환불 받을 수 있습니다. 서비스 이용
                        기준은 로그 기준(매물 상세 열람, 등기 열람 등 유료로 제공된 서비스의 사용 로그)으로 합니다. 단, 계약
                        유지조건을 전제로 한 유료 상품의 경우는 최초결제 시부터 7일 이내에만 서비스 미이용시 전액 환불 받을 수
                        있습니다.{" "}
                    </li>
                    <li className="redBox">
                        결제 시(=사용 개시)부터 7일 이내 사용내역이 있는 경우 및 결제 시부터 8일 이후 환불 시 공제 금액은 아래와
                        같이 적용됩니다.
                        <br /> - 연구독 상품, 계약 유지 조건이 없는 월구독 상품의 경우, 할인혜택이 소멸되어 정상금액에서
                        결제일부터 해지신청일까지의 이용일수에 해당하는 금액(=이용금액) 및 상품 정가 금액(결제 금액이 아님)의
                        20%(=위약금)를 제외한 나머지 금액이 환불됩니다.
                        <br /> - 공제 금액이 결제 금액 보다 큰 경우 환불 되는 금액이 없습니다.
                        <br />- 비구독 유료 상품은 해당 경우에 환불이 불가합니다.
                    </li>
                    <li className="redBox">
                        단, 계약 유지 조건이 있는 월구독 상품의 경우는 최초 결제시(최소 계약 유지 기간 시작시)부터 아래와 같이
                        적용됩니다.
                        <br />- 6개월, 1년과 같이 일정 기간(=계약 유지 기간)의 구독을 유지하는 조건으로 할인 혜택이 적용되는
                        월구독 상품에 해당됩니다.
                        <br /> -계약 유지 기간이 경과한 이후 해지할 경우 위약금이 발생하지 않습니다.
                        <br /> -계약 유지 기간 이내 해지할 경우 서비스 이용 개시 후 즉시 해지를 요청하더라도, 이미 결제된 월
                        구독권에 대한 환불은 불가하며, 서비스 이용은 구독권의 기간 만료시점까지 가능합니다.
                        <br /> - 계약 유지 기간 이내 해지 예약을 요청한 경우, 다음 결제일부터 자동 갱신이 중단되며, 최소 유지
                        기간을 조건으로 제공 받은 할인 혜택에 대한 위약금이 발생합니다.
                        <br /> - 위약금 : (상품 정가 금액 - 결제 금액) x 이용월수
                        <br /> - 월 구독 상품의 정가 금액 : 연 구독권 정가를 12개월로 나눈 금액 (원 단위 반올림)
                        <br /> ⁃ 월 구독 상품의 결제 금액 : 회사가 고지한 월별 실 결제 금액 (할인 적용된 금액)
                        <br /> ⁃ 이용월수 : 결제일을 기준으로 산정되는 월 단위 이용 주기(예: 매월 10일 ~ 다음 달 9일)를 기준으로,
                        각 주기 내 서비스 이용이 1일이라도 발생하면 해당 주기를 1개월로 계산 (해지 요청일이 주기 중간이라도, 해지
                        요청이 속한 주기는 1개월로 산정)
                    </li>
                    <li className="redBox">
                        구독 중도 해지 시 혜택으로 제공된 등기부등본 열람권, 캠퍼스 강의 등에 대한 서비스도 더 이상 제공되지
                        않습니다.
                    </li>
                    <li>
                        정기결제 구독을 구매한 경우 구독 갱신을 원하지 않는 경우 구독 기간이 끝나는 날로부터 최소 24시간 전에 자동
                        갱신 해지 예약을 해야 합니다
                    </li>
                    <li>
                        구독 해지 및 해지예약은 ‘내정보{">"}고객센터{">"}자주묻는질문’에서 가능합니다.
                    </li>
                    <li>
                        단, 앱마켓 결제의 경우 앱마켓 정책에 따라 결제/해지/환불이 이루어지며 해지/환불을 원하는 경우 앱마켓을
                        통해 신청해주기 바랍니다.
                    </li>
                    <li>추천인 구독 혜택 등 무료로 지급된 혜택은 환불 대상에서 제외됩니다.</li>
                    <li>본 약관은 25년 11월 13일부터 시행됩니다.</li>
                    <p>이전 약관</p>
                    <li
                        className="linkLi"
                        onClick={() => {
                            const a = document.createElement("a");
                            a.href = "https://triplenine.notion.site/2025-4-14-2025-11-12-2aab1e6b58cd80f9bc43db7acc1a188f";
                            a.target = "_blank";
                            a.click();
                        }}
                    >
                        2025년 4월 14일부터 2025년 11월 12일까지
                    </li>
                    <li
                        className="linkLi"
                        onClick={() => {
                            const a = document.createElement("a");
                            a.href = "https://triplenine.notion.site/3495c7e0a8ea4663977923fd0fe3b18c";
                            a.target = "_blank";
                            a.click();
                        }}
                    >
                        이전 약관 더 보기
                    </li>
                </div>
            ),
        },
    ];

    const appleSubscriptionUsingInfoTextList = [
        ...subscriptionUsingInfoTextList,
        {
            title: "Apple 전용 구독권 해지/취소/환불 안내",
            content: (
                <p css={contentStyle}>
                    <li>iPhone 및 iPad 전용 구독권으로, Apple ID에 등록된 결제수단으로 결제됩니다.</li>
                    <li>iOS 이용권은 Apple 미디어 서비스 이용 약관의 정책을 따릅니다.</li>
                    <li>
                        <span>
                            결제 금액은 부가세(VAT) 및 Apple 수수료 포함되어 있으며, 해외 원화 결제(DCC)에 따른 추가 수수료가
                            발생할 수 있습니다.
                        </span>
                    </li>
                    <li>
                        <span>
                            Apple ID에 등록된 결제수단으로 결제를 진행한 경우, 애플 정책에 따라 애플 웹 또는 iTunes를 통해서만
                            환불이 가능합니다. 자세한 환불 방법은 ‘자주묻는질문’에서 확인 부탁드립니다.
                        </span>
                    </li>
                    <li>
                        <span>
                            자동 결제 해지는 결제 예정일 최소 24시간 전에 해지 신청 해야 합니다. 결제 예정일 전 24시간 이내에는
                            자동 결제를 해지해도 이용권이 결제될 수 있습니다.
                        </span>
                    </li>
                    <li>
                        <span>
                            자동결제 해지는 [iTunes 및 App Store&gt;Apple ID 선택(우측 상단 프로필 아이콘)&gt;구독]에서
                            가능합니다. 이 경우 더이상 다음 결제가 이루어 지지 않으며, 남은 기간 동안 서비스 이용이 가능합니다.
                        </span>
                    </li>
                    <li>
                        <span>
                            자동 결제 예정일 전 24시간 이내에 결제가 이루어지며, App Store 자동 결제 예정일과 실제 이용권
                            구매일/만료일 표기는 결제 시점 및 시차 등의 이유로 다르게 표기될 수 있습니다.
                        </span>
                    </li>
                    <li>미스고 앱을 삭제해도 iTunes 구독이 취소되지 않으니 iTunes 및 App Store에서 구독을 취소해야 합니다.</li>
                </p>
            ),
        },
    ];

    const listByDeviceType = isApple ? appleSubscriptionUsingInfoTextList : subscriptionUsingInfoTextList;
    return (
        <div css={rootBoxStyle}>
            <div css={titleBoxStyle}>이용안내</div>
            <div css={contentRootStyle}>
                {listByDeviceType?.map((info, idx) => (
                    <TabAccordion square key={idx.toString()}>
                        <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
                            <div>{info?.title}</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Divider sx={{ margin: "0 18px", padding: 0 }} />
                            <div css={accordionContentStyle}>{info.content}</div>
                        </AccordionDetails>
                    </TabAccordion>
                ))}
            </div>
        </div>
    );
};

export default SubscriptionUsingInfo;

const TabAccordion = styled(Accordion)({
    boxShadow: "none",
    margin: "0 0 24px 0",
    backgroundColor: "#ffffff",
    borderRadius: "14px",
    border: "0.6px solid #0C002C",
    "&:before": {
        display: "none",
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(180deg)",
        color: "#2275EE",
    },
    "& .MuiAccordionSummary-root.Mui-expanded": {
        minHeight: "inherit",
        backgroundColor: "#ffffff",
        lineHeight: "24px",
        fontWeight: 700,
        fontSize: "14px",
        borderRadius: "14px 14px 0 0",
        padding: "14px",
    },
    "& .MuiAccordionSummary-content": {
        margin: 0,
    },
    "& .MuiAccordionSummary-root": {
        backgroundColor: "#ffffff",
        color: "#282828",
        padding: "14px",
        lineHeight: "24px",
        fontWeight: 700,
        fontSize: "14px",
        translation: "all 0.2s",
        borderRadius: "14px",
    },
    "& .MuiAccordionDetails-root": {
        color: "#282828",
        padding: 0,
    },
});

const rootBoxStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px 0;
`;

const titleBoxStyle = css`
    text-align: center;
    padding-bottom: 24px;
    color: #0c002c;
    font-size: 24px;
    font-weight: 400;
    line-height: 34px;
`;

const accordionContentStyle = css`
    padding: 14px;
    li {
        margin-left: 14px;
    }
`;

const contentRootStyle = css`
    width: 100%;
    padding: 0 14px;
`;

const titleStyle = css`
    color: #0c002c;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
`;
const contentStyle = css`
    white-space: pre-wrap;
    word-break: break-word;
    color: #505050;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    & > li {
        list-style: inside;
        margin-bottom: 2px;
        list-style-position: outside;
        color: #505050;
        font-size: 13px;
        font-weight: 400;
        line-height: 20px;
    }
    b {
        font-size: 13px;
        font-weight: 700;
    }
    .redBox {
        color: #ff0000;
    }
    & > .linkLi {
        text-decoration-line: underline;
        text-underline-position: under;
    }
    p {
        margin: 8px 0;
        font-size: 13px;
        font-weight: 700;
    }

    .titleBox {
        font-size: 13px;
        font-weight: 700;
        margin-top: 14px;
        margin-bottom: 4px;
        list-style: none;
    }
`;
